export const menuItems = [
  {
    title: "Home",
    url: "/",
  },
  {
    title: "Download",
    url: "download",
  },
  {
    title: "Visualize",
    url: "visualize",
  },
];
